var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoffeeBreaks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 58 58",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "025---Coffee",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m10.262 29.24c-1.33260951-.863164-2.89825464-1.296029-4.485-1.24-.41108915-.0114128-.78882117.2251626-.958.6-1.461 2.32-.819 8.44.746 11.51 1.391 2.72 3.114 4.28 7.045 3.46l1.67 1.948-.36 1.862c-1.0576284.2575034-2.1415068.3917299-3.23.4-3.84 0-6.71-1.95-8.7-5.89-1.91-3.76-3.05-11.43-.56-15.39.91573588-1.5585203 2.59239582-2.511168 4.4-2.5 1.43187391-.015485 2.85581327.2145099 4.21.68l1.086 1.764z",
    fill: "#f29c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m44 23.04c-.06321 4.1547892-.3737596 8.3021285-.93 12.42-2.23 15.77-7.55 18.54-7.55 18.54l-8.52 1-8.52-1s-5.32-2.77-7.55-18.54c-.5562404-4.1178715-.86679-8.2652108-.93-12.42-.03131408-.7810196.2513824-1.5420631.7849822-2.1132403.5335998-.5711773 1.2736755-.9049322 2.0550178-.9267597h28.32c.7813423.0218275 1.521418.3555824 2.0550178.9267597.5335998.5711772.8162963 1.3322207.7849822 2.1132403z",
    fill: "#f0c419"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m10 54h34c0 2.209139-1.790861 4-4 4h-26c-2.209139 0-4-1.790861-4-4z",
    fill: "#f29c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m58 2c0-1.1045695-.8954305-2-2-2h-17c-1.1045695 0-2 .8954305-2 2s.8954305 2 2 2 2 .8954305 2 2-.8954305 2-2 2h-5c-7 0-7 5-7 8 0 0 1-4 8-4h15c1.1045695 0 2-.8954305 2-2s-.8954305-2-2-2-2-.8954305-2-2 .8954305-2 2-2h6c1.1045695 0 2-.8954305 2-2z",
    fill: "#95a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m44 23.04c-.06321 4.1547892-.3737596 8.3021285-.93 12.42-2.96 6.85-9.05 11.54-16.07 11.54s-13.11-4.69-16.07-11.54c-.5562404-4.1178715-.86679-8.2652108-.93-12.42-.03131408-.7810196.2513824-1.5420631.7849822-2.1132403.5335998-.5711773 1.2736755-.9049322 2.0550178-.9267597h28.32c.7813423.0218275 1.521418.3555824 2.0550178.9267597.5335998.5711772.8162963 1.3322207.7849822 2.1132403z",
    fill: "#f3d55b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeeBreaks);
export default __webpack_public_path__ + "static/media/coffee-breaks.eb651bdb33af6e8ea2f4ca434c490ec8.svg";
export { ForwardRef as ReactComponent };